<template>
  <section class="page-hero">
    <v-container class="page-hero__inner">
      <p v-if="eyebrow" class="page-hero__eyebrow">{{ eyebrow }}</p>
      <h1 class="font-sora page-hero__title">{{ title }}</h1>
      <p v-if="lead" class="page-hero__lead">{{ lead }}</p>
      <div v-if="$slots.default" class="page-hero__extra">
        <slot />
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'PageHero',
  props: {
    eyebrow: { type: String, default: '' },
    title: { type: String, required: true },
    lead: { type: String, default: '' },
  },
};
</script>

<style scoped>
.page-hero {
  background: linear-gradient(180deg, #eef8f8 0%, #ffffff 78%);
  padding: 56px 0 28px;
  text-align: center;
}

.page-hero__inner {
  max-width: 820px;
}

.page-hero__eyebrow {
  display: inline-block;
  background: var(--brand-teal, #08a0a8);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  padding: 6px 14px;
  border-radius: 20px;
  margin: 0 0 18px;
}

.page-hero__title {
  color: var(--brand-navy, #002458);
  font-size: 40px;
  line-height: 1.15;
  font-weight: 700;
  margin: 0 0 14px;
}

.page-hero__lead {
  color: var(--brand-grey, #6b7280);
  font-size: 18px;
  line-height: 1.55;
  margin: 0 auto;
  max-width: 640px;
}

.page-hero__extra {
  margin-top: 24px;
}

@media screen and (max-width: 600px) {
  .page-hero {
    padding: 36px 0 20px;
  }

  .page-hero__title {
    font-size: 30px;
  }

  .page-hero__lead {
    font-size: 16px;
  }
}
</style>
